/* Configurable visual counter, not an analytics measurement. */
if (!customElements.get('brush-activity-counter')) {
  customElements.define('brush-activity-counter', class extends HTMLElement {
    connectedCallback() {
      clearInterval(this.timer);
      const first = Number(this.dataset.min) || 3;
      const last = Number(this.dataset.max) || 8;
      const min = Math.min(first, last), max = Math.max(first, last);
      this.textContent = Math.max(min, Math.min(max, Number(this.textContent) || min));
      this.timer = setInterval(() => {
        if (document.hidden || min === max) return;
        const current = Number(this.textContent);
        let next = min + Math.floor(Math.random() * (max - min));
        if (next >= current) next += 1;
        this.textContent = next;
      }, Math.max(4, Number(this.dataset.seconds) || 8) * 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}
